import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=78cd37bc&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78cd37bc')) {
      api.createRecord('78cd37bc', component.options)
    } else {
      api.reload('78cd37bc', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=78cd37bc&", function () {
      api.rerender('78cd37bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mD2ZaraIB5lp/JS/comp/CurrentYear.vue"
export default component.exports